var _rect, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIbCallAvayaIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#1DC06F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ib-call-avaya-icon_svg__clip0_7059_24769)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.499 5.733a.667.667 0 01.707.397l1.335 3.116a.667.667 0 01-.141.734l-.96.96a4.964 4.964 0 002.617 2.619l.96-.96a.667.667 0 01.735-.142l3.116 1.335c.277.119.44.409.397.707l-.42 2.94a.667.667 0 01-.629.571c-2.911.135-5.87-.91-8.094-3.134a10.712 10.712 0 01-3.134-8.094.667.667 0 01.572-.63l2.939-.42zM7.31 7.393a9.373 9.373 0 002.754 6.54 9.373 9.373 0 006.542 2.755l.267-1.872-2.232-.956-.945.946a.667.667 0 01-.682.16 6.297 6.297 0 01-3.983-3.982.667.667 0 01.161-.682l.946-.946-.957-2.231-1.87.267z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ib-call-avaya-icon_svg__clip0_7059_24769"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(5.333 5.333)",
    d: "M0 0h13.333v13.333H0z"
  })))));
}

export default SvgIbCallAvayaIcon;